import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-six',
  templateUrl: './demo-six.component.html',
  styleUrls: ['./demo-six.component.scss']
})
export class DemoSixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
